import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleNotch, faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { getStatusChipStyleVars } from "../../theme/gitoColors";
import { getToolDisplayLabel } from "../../helpers/agentEvents";

export default function AgentToolChips({ tools }) {
    const { t } = useTranslation();
    if (!tools?.length) {
        return null;
    }

    return (
        <div className="mt-2 flex flex-wrap gap-2">
            {tools.map((tool) => {
                const isError = tool.status === "error";
                const isDone = tool.status === "done";
                const chipStatus = isError ? "ERROR" : isDone ? "SUCCESS" : "CHARGING";
                return (
                    <span
                        key={tool.id}
                        className="chip pointer-events-none"
                        style={getStatusChipStyleVars(chipStatus)}
                    >
                        <FontAwesomeIcon
                            icon={isError ? faTriangleExclamation : isDone ? faCheck : faCircleNotch}
                            className={isDone || isError ? "" : "animate-spin"}
                        />
                        <p>{getToolDisplayLabel(t, tool.name)}</p>
                    </span>
                );
            })}
        </div>
    );
}
